/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Textures.FilterMode
 */

var CONST = {

    /**
     * CSV Map Type
     * 
     * @name Phaser.Textures.FilterMode.LINEAR
     * @type {number}
     * @since 3.0.0
     */
    LINEAR: 0,

    /**
     * CSV Map Type
     * 
     * @name Phaser.Textures.FilterMode.NEAREST
     * @type {number}
     * @since 3.0.0
     */
    NEAREST: 1
    
};

module.exports = CONST;



//////////////////
// WEBPACK FOOTER
// ./textures/FilterMode.js
// module id = 921
// module chunks = 0